var ReactRedux = require('react-redux');
var bindActionCreators = require('redux').bindActionCreators;
var PracticeActions = require('../../../modules/practice/actions/practice');
var PracticeLandingPage = require('../components/practiceLandingPage.jsx');
var RecordClick = require('../../../modules/meta/actions/register-click');
var RegisterActions = require('../../../modules/auth/actions/auth-register');

var mapStateToProps = function (state) {
  return {
    auth: state.auth,
    practice: state.practice,
  };
};

var mapDispatchToProps = function (dispatch) {
  return bindActionCreators(
    Object.assign({}, PracticeActions, RecordClick, RegisterActions),
    dispatch
  );
};

module.exports = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps
)(PracticeLandingPage);



// WEBPACK FOOTER //
// ./src/common/routes/practice/containers/practiceLandingPage.jsx